module.exports = __webpack_public_path__ + "static/media/montessori.cc29d840.png";


//////////////////
// WEBPACK FOOTER
// ./src/content/vychovakzivotu/resources/sponsors/montessori.png
// module id = 442
// module chunks = 0